import { showLoadingToast, showToast, closeToast } from 'vant';
// import store from '@/store';
// import router from '@/router'
// import { useRouter } from 'vue-router'
import { baseInstance} from './config';
export class Http {
  constructor(url) {
    this._url = url
    this._method = 'get'
    this._query = {}
    this._body = {}
    this._backAll = false
    this._hasLoading = true
    // this._hasToken = true
    this._header = { 'Content-Type': 'application/json; charset=utf-8' } // "Connection": "keep-alive"
    this._instance = baseInstance
    this._dataKey = 'ret_data'
  }

  instance(instance = baseInstance) {
    this._instance = instance
    return this
  }

  hasLoading(loading = true) {
    this._hasLoading = loading
    return this
  }

  // hasToken(hasToken = true) {
  //   this._hasToken = hasToken
  //   return this
  // }

  /**设置返回数据取值的key */
  setDataKey(key) {
    this._dataKey = key
  }

  method(method = 'get') {
    this._method = method
    return this
  }

  post() {
    this._method = 'post'
    return this
  }

  query(param = {}) {
    this._query = param
    return this
  }

  body(body = {}) {
    this._body = body
    return this
  }

  header(header = {}) {
    this._header = { ...this._header, ...header }
    return this
  }

  backAll(all = false) {
    this._backAll = all
    return this
  }

  exec(formatFunction = formatBaseResponse, tokenKey = 'gameUser/getToken') {
    if (this._hasLoading) {
      showLoadingToast({
        message: '加载中...',
        forbidClick: true,
      });
    }
    // if (this._hasToken && store) {
    //   const tempToken = store.getters[tokenKey]
    //   if(tempToken && !Reflect.has( this._header,"token"))
    //     this._header["Authorization"] = `Bearer ${tempToken}`
    // }
    return new Promise((resolve, reject) => {
      console.log('this._body: ', this._body)
      this._instance({
        url: this._url,
        method: this._method,
        params: this._query,
        data: this._body,
        headers: this._header
      }).then((res) => {
        if (this._hasLoading) {
          closeToast()
        }
        console.log('res: ', res,'--------------',this._backAll)
        if (this._backAll || !formatFunction) {
          resolve(res)
        } else {
          if(res)res.dataKey = this._dataKey
          formatFunction(res, resolve, reject)
        }
      }).catch((err) => {
        if (this._hasLoading) {
          closeToast()
        }
        console.log('err: ', err)
        showToast(err.message || '未知错误');
        reject(err)
      })
    })
  }
}

/**
 * 格式化基础返回数据
 * @param response
 * @param resolve
 * @param reject
 */
export function formatBaseResponse(response, resolve, reject) {
  if (response.ret_code === 0) {
    resolve(response.dataKey?response[response.dataKey] || response.ret_data : response.ret_data)
  }  else {
    showToast(response.ret_info || '未知错误');
    reject(response)
  }  
}
